import { z } from 'zod';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import {
  SubmitSignalFeedbackRequestSchema,
  SubmitSignalFeedbackResponseSchema,
} from './signal-feedback.schema';
import { SIGNAL_FEEDBACK_PATH_NAME } from './signal-feedback.constants';

export const SignalFeedbackContract = terraContract
  .prefix(`/${SIGNAL_FEEDBACK_PATH_NAME}`)
  .router({
    submitFeedback: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/',
        summary: 'Submit signal feedback',
        description:
          'Submit user feedback for signal classification changes (HOT to PASSED/COLD) to help improve detection accuracy',
        inputStructure: 'detailed',
      })
      .input(z.object({ body: SubmitSignalFeedbackRequestSchema }))
      .output(SubmitSignalFeedbackResponseSchema),
  });
